import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import ProductVariation from "../product/ProductVariation";
import Country from "../country/Country";
import moment from "moment";
import { date_time_format } from "../../mcn-helpers";
import JsonMappedModel from "../helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Inventory extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Inventory.id_attribute_name]: null,
      [Inventory.variation_attribute_name]: ProductVariation,
      [Inventory.inventory_quantity_attribute_name]: null,
      [Inventory.country_id_attribute_name]: null,
      [Inventory.product_id_attribute_name]: null,
      [Inventory.inventory_country_attribute_name]: Country,
      [Inventory.inventory_cost_attribute_name]: 0,
      [Inventory.inventory_type_attribute_name]: null,
      [Inventory.inventory_total_quantity_attribute_name]: 0,
      [Inventory.inventory_quantity_sum_attribute_name]: 0,
      [Inventory.inventory_cost_sum_attribute_name]: 0,
      [Inventory.inventory_unitary_cost_sum_attribute_name]: 0,
      [Inventory.inventory_unitary_cost_attribute_name]: 0,
      [Inventory.inventory_remaining_quantity_attribute_name]: 0,
      [Inventory.deleted_at_attribute_name]: null,
      [Inventory.created_at_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  getId() {
    return this.getAttribute(Inventory.id_attribute_name);
  }
  getCreationDate() {
    return this.getAttribute(Inventory.created_at_attribute_name);
  }
  getDeletionDate() {
    return this.getAttribute(Inventory.deleted_at_attribute_name);
  }
  getMomentCreationDate() {
    let date = this.getCreationDate();
    return date ? moment(this.getCreationDate()).format(date_time_format) : null;
  }
  getMomentDeletionDate() {
    let date = this.getDeletionDate();
    return date ? moment(date).format(date_time_format) : null;
  }
  getVariation() {
    return this.getAttribute(Inventory.variation_attribute_name);
  }
  getCost() {
    return this.getAttribute(Inventory.inventory_cost_attribute_name);
  }
  getUnitaryCost() {
    return this.getAttribute(Inventory.inventory_unitary_cost_attribute_name);
  }
  getVariationSku() {
    let variation = this.getVariation();
    return variation instanceof ProductVariation ? variation.getSku() : null;
  }
  getQuantity() {
    return this.getAttribute(Inventory.inventory_quantity_attribute_name);
  }
  getCountry() {
    return this.getAttribute(Inventory.inventory_country_attribute_name);
  }
}
_defineProperty(Inventory, "PRIVATE_TYPE", 'private');
_defineProperty(Inventory, "OUTSOURCED_TYPE", 'outsourced');
_defineProperty(Inventory, "id_attribute_name", 'inventory_id');
_defineProperty(Inventory, "variation_attribute_name", 'variation');
_defineProperty(Inventory, "inventory_quantity_attribute_name", 'inventory_quantity');
_defineProperty(Inventory, "country_id_attribute_name", 'country_id');
_defineProperty(Inventory, "product_id_attribute_name", 'product_id');
_defineProperty(Inventory, "inventory_country_attribute_name", 'inventory_country');
_defineProperty(Inventory, "inventory_cost_attribute_name", 'inventory_cost');
_defineProperty(Inventory, "inventory_type_attribute_name", 'inventory_type');
_defineProperty(Inventory, "inventory_total_quantity_attribute_name", 'inventory_total_quantity');
_defineProperty(Inventory, "inventory_quantity_sum_attribute_name", 'inventory_quantity_sum');
_defineProperty(Inventory, "inventory_cost_sum_attribute_name", 'inventory_cost_sum');
_defineProperty(Inventory, "inventory_unitary_cost_sum_attribute_name", 'inventory_unitary_cost_sum');
_defineProperty(Inventory, "inventory_unitary_cost_attribute_name", 'inventory_unitary_cost');
_defineProperty(Inventory, "inventory_remaining_quantity_attribute_name", 'inventory_remaining_quantity');
_defineProperty(Inventory, "deleted_at_attribute_name", 'deleted_at');
_defineProperty(Inventory, "created_at_attribute_name", 'created_at');